import { createSubstore } from 'storeon-substore';
import type { Store } from 'store/types';
import { getLandingsInfo } from './landings-info-actions';
import { FETCH_LANDINGS, LANDINGS_STORE_NAME } from './landings-info-constants';
import type { LandingsInfoStore } from './landings-info-types';

const INITIAL_STATE: LandingsInfoStore = {
  landingsList: null,
  loading: false,
  error: null,
} as const;

export const landings = (parentStore: Store) => {
  const store = createSubstore(parentStore, LANDINGS_STORE_NAME);
  store.on('@init', () => INITIAL_STATE);
  store.on(FETCH_LANDINGS.init, async (_, { landingName, isAvailable }) => {
    const { loading } = store.get();
    const { modelJson } = parentStore.get();
    if (!modelJson.model || loading) {
      return Promise.resolve();
    }
    store.dispatch(FETCH_LANDINGS.request);

    try {
      const landingsList = await getLandingsInfo(
        parentStore,
        modelJson.model.properties.regionId,
        landingName,
        isAvailable
      );
      store.dispatch(FETCH_LANDINGS.success, landingsList);
    } catch (e) {
      store.dispatch(FETCH_LANDINGS.failure, (e as Error).message);
    }

    return Promise.resolve();
  });
  store.on(FETCH_LANDINGS.request, state => ({ ...state, loading: true }));
  store.on(FETCH_LANDINGS.failure, (state, error) => ({
    ...state,
    error,
    loading: false,
    landingsList: null,
  }));
  store.on(FETCH_LANDINGS.success, (state, res) => ({ ...state, landingsList: res, loading: false }));
};
